import React, { Suspense } from 'react';
import Spinner from '../components/spinner';

// Lazy-loaded components

const HomePageMainSlider = React.lazy(() => import('./home/HomePageMainSlider'));
const HomePageAbout = React.lazy(() => import('./home/HomePageAbout'));
const HomePageServies = React.lazy(() => import('./home/HomePageServices'));
const HomePageCta = React.lazy(() => import('./home/HomePageCta'));
const HomePageTestimonial = React.lazy(() => import('./home/HomePageTestimonial'));
const HomepageCases = React.lazy(() => import('./home/HomepageCases'));
const HomePageBrand = React.lazy(() => import('./home/HomePageBrand'));
const HomePageContact = React.lazy(() => import('./home/HomePageContact'));
const HomePageBlog = React.lazy(() => import('./home/HomePageBlog'));
const HomePageWhyChoose = React.lazy(() => import('./home/HomePageWhyChoose'));
const HomePageTabs = React.lazy(() => import('./home/HomePageTabs'));
const HomePageCounter = React.lazy(() => import('./home/HomePageCounter'));
const HomePageFAQ = React.lazy(() => import('./home/HomePageFAQ'));


function Index() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />}>
       <HomePageMainSlider />
       <HomePageAbout />
       <HomePageServies />
       <HomePageWhyChoose />
       {/* <HomePageTabs /> */}
       <HomePageCounter />
       <HomePageFAQ />
       <HomepageCases />
       {/* <HomePageCta /> */}
       <HomePageTestimonial />
       {/* <HomePageBlog /> */}
       {/* <HomePageBrand /> */}
       <HomePageContact />
      </Suspense>
    </div>
  );
}

export default Index;
